(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mys-shop-by-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mys-collection-carousel')) {
    customElements.define('mys-collection-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.dotsWrap = this.querySelector('[data-dots]');
        this.dots = this.dotsWrap ? Array.from(this.dotsWrap.children) : [];
        if (!this.track) return;

        this.onScroll = () => this.update();
        this.onResize = () => this.update();
        this.prev.addEventListener('click', () => this.go(-1));
        this.next.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.querySelectorAll('img').forEach((img) => {
          if (!img.complete) img.addEventListener('load', this.onResize, { once: true });
        });
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }
      step() {
        const slide = this.track.querySelector('.mys-sbc__slide');
        if (!slide) return 0;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }
      go(dir) {
        this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
      }
      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        const scrollable = max > 2;

        this.prev.hidden = !scrollable;
        this.next.hidden = !scrollable;
        this.prev.disabled = t.scrollLeft <= 2;
        this.next.disabled = t.scrollLeft >= max - 2;

        const media = t.querySelector('[data-media]');
        if (media) this.style.setProperty('--mys-sbc-arrow-top', (media.offsetHeight / 2) + 'px');

        if (this.dotsWrap) {
          this.dotsWrap.classList.toggle('is-scrollable', scrollable);
          const s = this.step() || 1;
          const i = Math.round(t.scrollLeft / s);
          this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
